import { DecoratorService } from '../services/decorator.service';

export function BulkOperation(message?: string) {
  return function (
    _: object,
    _methodName: string,
    descriptor: PropertyDescriptor
  ) {
    const originalMethod = descriptor.value;

    descriptor.value = function (...args: any[]) {
      DecoratorService.getToastr()?.info(
        message || 'Records are being updated, it might take a few minutes for the processing to complete.',
        'Processing Updates',
        {
          positionClass: 'toast-bottom-right',
          timeOut: 5000,
          closeButton: true
        }
      );

      return originalMethod.apply(this, args);
    };
  };
} 